import { formatCell } from '../../../utils/numbers';

const LOCALE = 'en-US';

export const compactNumber = value =>
    new Intl.NumberFormat(LOCALE, { notation: 'compact', maximumFractionDigits: 1 }).format(value);

export const groupedNumber = value => new Intl.NumberFormat(LOCALE).format(value);

const normalizeDisplayFormat = displayFormat =>
    displayFormat?.type === 'currency' ? { ...displayFormat, symbol: displayFormat.symbol || '$' } : displayFormat;

export const displayNumber = (value, displayFormat, { compact = true } = {}) => {
    const format = normalizeDisplayFormat(displayFormat);
    if (format?.type === 'percentage') {
        return `${Number((value * 100).toFixed(format.precision ?? 1))}%`;
    }
    if (compact && Math.abs(value) >= 1000) {
        return formatCell(compactNumber(value), format);
    }
    return format ? formatCell(value, format) : groupedNumber(value);
};

export const formatKpiValue = (value, format, unit, { compact = true } = {}) => {
    if (typeof value !== 'number' || !Number.isFinite(value)) {
        return String(value);
    }

    switch (format) {
        case 'currency':
            return displayNumber(value, { type: 'currency', symbol: unit }, { compact });
        case 'percent':
            return displayNumber(value, { type: 'percentage' });
        case 'number': {
            const formatted = displayNumber(value, undefined, { compact: false });
            return unit ? `${formatted} ${unit}` : formatted;
        }
        default:
            return String(value);
    }
};

export const formatKpiDelta = delta => {
    if (typeof delta !== 'number' || Number.isNaN(delta)) {
        return null;
    }

    const pct = Number((delta * 100).toFixed(1));
    const direction = pct > 0 ? 'up' : pct < 0 ? 'down' : 'flat';
    const sign = pct > 0 ? '+' : '';
    return { text: `${sign}${pct}%`, direction };
};
